import { useMutation } from 'react-query';
import batteryServices from './battery.services';
import notificationError from '@/utils/functions/notificationError';

export function usePortoBatteryWarranty() {
  return useMutation({
    mutationFn: batteryServices.detail,
    onError(error) {
      notificationError(error);
    },
  });
}
